/* global process */
let debug = false;
try {
  debug = !!globalThis.localStorage.debug;
} catch {
  // ignore
}
export const HAS_DEBUG_FLAG = debug || false;
export const HAS_WINDOW = typeof globalThis !== 'undefined';
export const IS_BROWSER = HAS_WINDOW || typeof globalThis !== 'undefined';
export const IS_PROD = process.env.NODE_ENV === 'production';

Array.prototype.tap = function (fn) {
  fn(this);
  return this;
};

const fallback = func => {
  setTimeout(func, 0);
};

export const raf = IS_BROWSER && globalThis.requestAnimationFrame ? globalThis.requestAnimationFrame : fallback;
export const ric = IS_BROWSER && globalThis.requestIdleCallback ? globalThis.requestIdleCallback : fallback;

export const debounce = (fn, wait) => {
  let timeout;
  const debounced = (...args) => {
    const ctx = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(ctx, args);
    }, wait);
  };
  debounced.cancel = () => {
    clearTimeout(timeout);
  };
  return debounced;
};

export const findOrInitializeById = (byId, id) => (byId && byId[id]) || { id: Number(id) };
